'use strict';

import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { format } from 'date-fns';
import cn from 'classnames/bind';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getWeekDates } from '@/state/utilities';

import { appSelectors, appOperations } from '@/state/domains/app';

import Link from '@/views/common/Link';

import s from './styles.scss';

const sx = cn.bind(s);

const icons = {
	next: 'chevron-right',
	prev: 'chevron-left',
};

const urls = {
	'user-weekly': (username, date) => `/user/${ username }/${ date }`,
	'daily-route': (username, date) => `/user/${ username }/${ date }/route`,
};

const Nav = connect(
	(state, props) => ({
		pageId: appSelectors.getPageId(state, props),
		weekNav: appSelectors.getWeekNav(state, props),
		dayNav: appSelectors.getDayNav(state, props),
		location: appSelectors.getLocation(state, props),
	}),
	{
	}
)(
	({ pageId, username, date, weekNav, dayNav, direction, location }) => {

		const navs = {
			'user-weekly': weekNav,
			'daily-route': dayNav,
		};

		const nav = navs[ pageId ];

		let url = '';
		let title = '';
		let goDate = date in nav ? nav[ date ][ direction ] : null;

		if (goDate) {
			title = format(new Date(goDate + ' 00:00:00'), 'MMMM do');
			url = urls[ pageId ](username, goDate);
		}

		if (!goDate) {
			return (
				<div className={ sx('nav', 'disabled') } title={ title } >
					<FontAwesomeIcon icon={ icons[ direction ] } />
				</div>
			);
		}

		const locObj = { pathname: url };

		if (location.state) {
			locObj.state = location.state;
		}

		return (
			<div className={ s.nav } title={ title } >
				<Link to={ locObj } className={ s.link } title={ title }>
					<FontAwesomeIcon icon={ icons[ direction ] } />
				</Link>
			</div>
		);
	}
);

export default connect(
	(state, props) => ({
		pageId: appSelectors.getPageId(state, props),
		date: appSelectors.getPageDate(state, props),
		username: appSelectors.getPageUsername(state, props),
	}),
	{
	}
)(
	({
		date,
		username,
		pageId,
	}) => {

		let weekDates = getWeekDates(date);
		const weekStart = format(weekDates[ 0 ], 'EEE MMM do');
		const weekEnd = format(weekDates[ 4 ], 'EEE MMM do');

		const dateLabel = pageId === 'user-weekly' ?
			`${ weekStart } — ${ weekEnd }` :
			weekStart;

		return (
			<div className={ s.dateUI }>
				<Nav date={ date } username={ username } direction='prev' />
				<div className={ s.label }>
					<FontAwesomeIcon icon='calendar-days' color='#444' />&nbsp;&nbsp;
					{ dateLabel }
				</div>
				<Nav date={ date } username={ username } direction='next' />
			</div>
		);
	}
);
